<template>
  <div id="app">

    <!--头部-->
    <div class="gwHeader">
      <div class="logoDiv">
          <a href="#/index" title="">
            <img src="@/assets/logo.png" alt="" class="tt" />
          </a>
      </div>
      <div id="navbar">
        <div><a href="#/index">首页</a></div>
        <div><a href="http://live.xw100.com/" target="_blank">“培优·顶尖”课程</a></div>
        <div><a href="javascript:void(0);" @click="seteJump(1);" id="youshi_t">学为优势</a></div>
        <div><a href="javascript:void(0);" @click="seteJump(2);" id="kctx_t">课程体系</a></div>
        <div><a href="#/aboutUs">关于学为</a></div>
      </div>

    </div>

    <router-view/>

    <div class="gwBottomDiv">

      <div class="bottomDiv">
        <div>
          Copyright©增值电信业务经营许可证：<a target="_blank" href="https://beian.miit.gov.cn" style="color: #9D9D9D;">京ICP备13043318号-1 </a> &nbsp; &nbsp; &nbsp;北京学为教育科技有限公司版权所有
        </div>

        <!-- <div>
          地址：北京市海淀区闵庄路清琴麓院东院1号楼（总部）
        </div> -->

        <div>
          地址：北京市海淀区中关村大街甲28号海淀文化艺术大厦B座B1层
        </div>

      </div>

    </div>

    <div class="homeHungWindows">

      <div class="appDowmDiv">
        <div class="appDowmTitle">
          <div>学为课堂</div>
          <div>APP</div>
        </div>
        <div class="dowmImg">
          <img src="http://static.xw100.com/live/img/ewm.png">
        </div>
      </div>

      <div class="wxgzhDiv">
        <div class="wxgzhTitle">
          <div>学为</div>
          <div>微信公众号</div>
        </div>
        <div class="wxgzhImg">
          <img src="http://static.xw100.com/live/img/erweima.jpg">
        </div>
      </div>

      <div class="xwPhoneDiv">
        <div class="xwPhoneTitle">
          联系我们
        </div>
        <div class="xwPhoneNum">
          400-001-7799
        </div>
      </div>

      <div class="goTopDiv" @click="goTop">
        <img src="@/assets/img/11.png">
      </div>

    </div>


    <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
    <!-- <HelloWorld /> -->
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'App',
  components: {
    // HelloWorld
  },
  mounted(){

  },
  methods: {
    seteJump(type){
      // document.getElementById("target").scrollIntoView(1000);

      if(type == 1){

        if( this.$route.path == "/index"){
          this.$nextTick(()=>{
            window.scrollTo({
              top: 850,
              behavior: 'smooth'
            });
          })
          
        }else {
          this.$router.push('/index');
          this.$nextTick(()=>{
            window.scrollTo({
              top: 850,
              behavior: 'smooth'
            });
          })

        }

      }else if(type == 2){

        if( this.$route.path == "/index"){
          this.$nextTick(()=>{
            window.scrollTo({
              top: 1250,
              behavior: 'smooth'
            });

          })
          
        }else {
          this.$router.push('/index');
          this.$nextTick(()=>{
            window.scrollTo({
              top: 1250,
              behavior: 'smooth'
            });
          })

        }

      }

      
      
    },
    goTop(){
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });

    }
    
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  min-width: 1200px;
  /* color: #2c3e50; */
}
a {
  text-decoration: none;
  color: #333;
}
a:hover{
    color: #0457B9;
    text-decoration:none;
}
.gwHeader {
  width: 1200px;
  height: 100px;
  margin: 0 auto;
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
}
.logoDiv {
  margin: 20px 0;
}
#navbar {
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  line-height: 100px;
  margin-left: 40px;
}
#navbar div {
  margin-left: 40px;
}
#navbar a {
  color: #000000;
  text-decoration: none;
}
#navbar a:hover{
    color: #0457B9;
    text-decoration:none;
}
img {
  vertical-align: middle;
}
.gwBottomDiv {
  width: 100%;
  height: 200px;
  background-color: #444547;
  color: #9D9D9D;
}
.bottomDiv {
  width: 1200px;
  text-align: center;
  margin: 0 auto;
  padding-top: 40px;
}
.bottomDiv div {
  margin: 20px 0;
}

.homeHungWindows {
  position: fixed;
  right: -3px;
  bottom: 20%;
  text-align: center;
  border-radius: 4px;
  z-index: 99999;
  color: #63A3FF;
  font-size: 12px;
  cursor: pointer;
  border-radius: 24px 0 0 24px;
}

.appDowmDiv {
  width: 90px;
  height: 90px;
  background: url("./assets/img/xfs.png") no-repeat;
  background-size: 100% 100%;
  padding: 25px 5px;
  box-sizing: border-box;
  position: relative;
}

.appDowmDiv:hover .dowmImg {
  display: block;
}

.dowmImg {
  position: absolute;
  top: 20px;
  left: -100px;
  width: 80px;
  height: 80px;
  background-color: #63A3FF;
  border-radius: 15px 0 15px 15px;
  padding: 10px 10px;
  display: none;
}

.dowmImg img {
  width: 100%;
  height: 100%;
}

.wxgzhDiv {
  width: 90px;
  height: 90px;
  padding: 25px 5px;
  background: url("./assets/img/xfz.png") no-repeat;
  background-size: 100% 100%;
  position: relative;
  box-sizing: border-box;
  top: -7px;
}

.wxgzhDiv:hover .wxgzhImg {
  display: block;
}

.wxgzhImg {
  position: absolute;
  top: 10px;
  left: -100px;
  width: 80px;
  height: 80px;
  background-color: #63A3FF;
  border-radius: 15px 0 15px 15px;
  padding: 10px 10px;
  display: none;
}

.wxgzhImg img {
  width: 100%;
  height: 100%;
}

.xwPhoneDiv {
  width: 90px;
  height: 90px;
  padding: 30px 5px;
  background: url("./assets/img/xfz.png") no-repeat;
  background-size: 100% 100%;
  position: relative;
  box-sizing: border-box;
  top: -14px;
}

.xwPhoneDiv:hover .xwPhoneNum {
  display: block;
}

.xwPhoneNum {
  position: absolute;
  top: 20px;
  left: -145px;
  width: 130px;
  height: 30px;
  line-height: 30px;
  background-color: #fff;
  border: 5px solid #63A3FF;
  color: #63A3FF;
  font-weight: 700;
  border-radius: 5px 5px;
  display: none;
}

.goTopDiv {
  width: 90px;
  height: 90px;
  padding: 25px 5px;
  background: url("./assets/img/xfx.png") no-repeat;
  background-size: 100% 100%;
  position: relative;
  box-sizing: border-box;
  top: -21px;
}

.goTopDiv img {
  width: 25px;
  height: auto;
  vertical-align: middle;
}


</style>
